module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "map"
    }
  }), _c('strong', [_c('em', [_vm._v("Maps")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/frontm02#map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. The Philippines Area")])]), _vm._v(" "), _c('p', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#map2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Approach of the Nishimura and Shima forces")])]), _vm._v(" "), _c('p', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/app01#map3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Battle of Surigao Strait, general main action")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a712d416","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/maps.vue
// module id = 78
// module chunks = 0